<script>
import swal from "sweetalert";
import {deleteCompanyTokens} from "@/api/accounts.js";

export default {
  name: "api-key-box",
  components: {
    
  },
  props: {
    item: Object,
  },
  data() {
    return {
      timeout: 2000,
      loadingDelete: false
    };
  },
  async mounted() {

  },
  watch:{
    
  },
  computed: {
  },
  methods: {
    copy() {
    },
    copyApi(data){
      this.$refs.copyClipboard.focus();
      document.execCommand('copy');
      this.$bvToast.toast(`Copied to Clipboard`, {
        title: "Note",
        autoHideDelay: 3000,
        appendToast: false,
        variant: "info"
      });
    },
    async deleteApi(data){
      this.loadingDelete = true
      let resp = await deleteCompanyTokens(data)
      this.$emit('contentRefresh')
      swal("Done!", "Successfully deleted");
      this.loadingDelete = false
    }
  }
};
</script>

<template>
  <div class="api-item-container" v-if="item">
    <div class="h3">
      {{item.name}}
    </div>
    <v-text-field
      v-on:focus="$event.target.select()" 
      :value="item.token"
      ref="copyClipboard" 
      label="API Key"
      readonly
    ></v-text-field>
    <div class="align-center">
      <v-btn
        class="blue white--text mr-2 caption"
        small
        @click="copyApi()">
          <v-icon  
          color="white"
          small>
              mdi-content-copy
          </v-icon>
          Copy
      </v-btn>
      <v-btn
        class="red lighten-1 white--text caption"
        small
        @click="deleteApi(item.pk)">
          <v-icon  
          color=""
          small>
              mdi-delete-outline
          </v-icon>
          Delete
      </v-btn>
      <v-overlay :value="loadingDelete">
        <div class="text-center">
          <p>Processing ...</p>
          <v-progress-circular v-if="loadingDelete" indeterminate size="30"></v-progress-circular>
        </div>
      </v-overlay>
      
    </div>
  </div>
</template>

<style scoped>
</style>
